/* web/style.css .badge / .badge.warn */
.badge { align-self: flex-start; font-size: 12px; font-weight: 600; padding: 4px 10px; border-radius: 999px; background: var(--fill); color: var(--muted); border: 0; }
.badge:disabled { cursor: default; }
.warn { background: var(--warning); color: var(--on-color); }
